import * as React from "react";
import styled, { css } from "styled-components";
import { Theme } from "../../../../theme";
import { useTheme } from "@material-ui/styles";
import { CameraHook } from "../../../../hooks/useCameras";
import {
  useCameraOptions,
  CameraOptionsHook,
} from "../../../../hooks/useCameraOptions";
import ControlBar from "../../Camerasv2/ControlBar";
import CameraContent from "../../Camerasv2/CameraContent";
import { Site } from "../../../../services/cameraService";
import { overallRisk } from "../../Camerasv2/measurementRisk";
import { RISK_WEIGHTS } from "../../../../constants/matrix";
import { useEffect } from "react";
import debounce from "lodash.debounce";

const TEN_MINS = 10 * 60 * 1000;
const DEBOUNCE_INTERVAL = 4000; //4s

const StyledSection = styled.section`
  width: 100%;
  height: calc(100% - 8px);
  margin-top: 4px;
  padding: 12px;
  display: flex;
  flex-direction: column;

  ${({ theme }: { theme: Theme }) => {
    return css`
      #controlBar {
        border: 1px solid black;
        border-radius: 5px;
        height: 40px;
        margin-bottom: 8px;
      }
      #cameraContent {
        border: 1px solid black;
        border-radius: 5px;
        flex: 1;
      }
    `;
  }};
`;

export interface CamerasViewProps {
  cameraHook: CameraHook;
}

const CamerasView: React.FC<CamerasViewProps> = props => {
  const theme: Theme = useTheme();
  const cameraOptionsHook: CameraOptionsHook = useCameraOptions();
  const { deployments, liveState } = props.cameraHook.data;
  const { options } = cameraOptionsHook;

  //#0F0 Change this
  //Temporary approach --> will need to seperate historical and present data later
  // useEffect(() => {
  //   if (!options.live) {
  //     props.cameraHook.methods.resetData(options.startTime);
  //   } else {
  //     props.cameraHook.methods.resetData(new Date());
  //   }
  // }, [options.startTime, options.live]);

  //When Time picked changes, and not equal to some time within the past 10 minutes,
  //Fetch the historical data.
  useEffect(() => {
    if (options.startTime < new Date(+new Date() - TEN_MINS)) {
      const getMoreData = debounce(
        async () => {
          await props.cameraHook.methods.resetPastData(options.startTime);
        },
        DEBOUNCE_INTERVAL,
        { trailing: true }
      );
      getMoreData();
    }
  }, [options.startTime]);

  //Get available sites
  const sites = deployments
    .filter(v => v.site !== null)
    .map(v => v.site!.siteName);
  const avaiableSites = [...new Set(sites)] as string[];
  //Get risk counts
  const riskArray = deployments.map(d => {
    const state = liveState[d.deploymentId];
    if (state) {
      return overallRisk(state, RISK_WEIGHTS).val;
    } else {
      return 0;
    }
  });
  const risks = {
    low: riskArray.filter(v => v === 1).length,
    medium: riskArray.filter(v => v === 3).length,
    high: riskArray.filter(v => v === 4).length,
  };

  console.log(props.cameraHook);

  return (
    <>
      <StyledSection theme={theme}>
        <ControlBar
          cameraOptionsHook={cameraOptionsHook}
          sites={avaiableSites}
          risks={risks}
        ></ControlBar>
        <CameraContent
          cameraOptionsHook={cameraOptionsHook}
          cameraHook={props.cameraHook}
        ></CameraContent>
      </StyledSection>
    </>
  );
};

export default CamerasView;
